import React from "react";

const CTA = () => {
  return (
    <div className="cta">
      <a
        href="https://drive.google.com/drive/folders/1wGDNrHRTARs8jK5w3o0JAK1Yw0Ch2Ll0"
        target="_blank"
        className="btn"
        rel="noreferrer"
      >
        Resume
      </a>
      <a href="#contact" className="btn btn-primary">
        Let's talk
      </a>
    </div>
  );
};

export default CTA;
